<template lang="html">
  <section>
    <v-container fluid class="pa-0 p-relative index-1">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <div class="banner">
            <v-img :src="require('@/assets/images/bg_menubook.jpg')" :aspect-ratio="6/4" alt="Banner menu" />
          </div>
          <div class="banner-text">
            <div class="detail-store">
              <div class="detail-store-logo">
                <img :src="$store.state.selected_store.logo" :alt="$store.state.selected_store.name">
              </div>
              <div>
                <div v-if="$store.state.selected_store" class="title-store">
                  {{ $store.state.selected_store.name }}
                </div>
                <div class="subtitle-store text-two-line">
                  {{ $store.state.selected_store.address }}
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="py-0 p-relative">
      <v-row>
        <v-col v-if="listCombo.length > 0" v-scroll="onScrollCombo" cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pb-0">
          <div class="background-image-blur" :style="{ 'background-image': 'linear-gradient( rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8)) , url(' + getImgUrl('bg_theme0001.jpg') + ') !important' }" />
          <div id="product_combo" class="p-relative index-1">
            <div :class="[`title-group-product mx-3`, { 'mt-8 mb-6': listCombo.length !== 0 }]">
              Paket produk
            </div>
            <v-row class="mx-0">
              <template v-for="(detail, index) in listCombo">
                <v-col v-if="index <= 3" :key="index + 'grid-product'" cols="6">
                  <v-card class="yellow-card card-product-grid rounded-lg" @click="detailMenu(detail.id, 'combo')">
                    <v-img :src="detail.photo_md" :aspect-ratio="1/1" />
                    <v-card-text class="font-weight-bold py-2 px-3">
                      <div class="text-two-line font-merriweather">
                        {{ detail.name }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </template>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-list class="list-product-menu-book">
                  <template v-for="(detail, index) in listCombo">
                    <v-list-item v-if="index > 3" :key="index + '-product'" :ripple="false" @click="detailMenu(detail.id, 'combo')">
                      <v-list-item-avatar size="88" tile class="rounded-lg">
                        <v-img :src="detail.photo_md" />
                      </v-list-item-avatar>
                      <v-list-item-content class="align-self-start">
                        <v-list-item-title class="font-merriweather title-product mb-2 theme0001--text" v-html="detail.name" />
                        <template v-if="$store.state.selected_store.setting.show_price_book_menu">
                          <v-list-item-subtitle v-mask-money="detail.sell_price_pos" class="font-merriweather subtitle-product white--text" />
                        </template>
                        <v-list-item-subtitle v-else class="font-merriweather subtitle-product white--text">
                          {{ detail.description }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- {{ listProduct }} -->
        <v-col v-scroll="onScroll" cols="12" sm="6" offset-sm="3" md="4" offset-md="4" :class="[{ 'pt-0': listCombo.length !== 0 }]">
          <div class="background-image-blur" :style="{ 'background-image': 'linear-gradient( rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8)) , url(' + getImgUrl('bg_theme0001.jpg') + ') !important' }" />
          <div v-for="(item, idx) in listProduct" :id="'product_' + item.product_group_id" :key="idx + '-item-product'" class="p-relative index-1">
            <div :class="[`title-group-product mx-3`, { 'mt-8 mb-6': idx === 0 && listCombo.length === 0 }, { 'mt-2': idx !== 0 && listCombo.length === 0 }]">
              {{ item.product_group_name }}
            </div>
            <template v-if="idx === 0 && listCombo.length === 0">
              <v-row :class="[`mx-0`, { 'pt-2': listCombo.length !== 0 }]">
                <template v-for="(detail, index) in item.items">
                  <v-col v-if="index <= 3" :key="index + 'grid-product'" cols="6">
                    <v-card class="yellow-card card-product-grid rounded-lg" @click="detailMenu(detail.id)">
                      <v-img :src="detail.photo_md" :aspect-ratio="1/1" />
                      <v-card-text class="font-weight-bold py-2 px-3">
                        <div v-if="detail.default_variant_id" class="text-two-line font-merriweather">
                          {{ detail.alt_name === '' ? detail.name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'name') + ')' : detail.name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'name') + ')' + ' / ' + detail.alt_name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'alt_name') + ')' }}
                        </div>
                        <div v-else class="text-two-line font-merriweather">
                          {{ detail.alt_name === '' ? detail.name : detail.name + ' / ' + detail.alt_name }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </template>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-list class="list-product-menu-book">
                    <template v-for="(detail, index) in item.items">
                      <v-list-item v-if="index > 3" :key="index + '-product'" :ripple="false" @click="detailMenu(detail.id)">
                        <v-list-item-avatar size="88" tile class="rounded-lg">
                          <v-img :src="detail.photo_md" />
                        </v-list-item-avatar>
                        <v-list-item-content class="align-self-start">
                          <v-list-item-title v-if="detail.default_variant_id" class="font-merriweather title-product mb-2 theme0001--text">
                            {{ detail.alt_name === '' ? detail.name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'name') + ')' : detail.name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'name') + ')' + ' / ' + detail.alt_name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'alt_name') + ')' }}
                          </v-list-item-title>
                          <v-list-item-title v-else class="font-merriweather title-product mb-2 theme0001--text">
                            {{ detail.alt_name === '' ? detail.name : detail.name + ' / ' + detail.alt_name }}
                          </v-list-item-title>
                          <template v-if="$store.state.selected_store.setting.show_price_book_menu">
                            <v-list-item-subtitle v-if="detail.default_variant_id" v-mask-money="$getObjectArray(detail.variants, 'id', detail.default_variant_id, 'sell_price_pos')" class="subtitle-product white--text" />
                            <v-list-item-subtitle v-else v-mask-money="detail.sell_price_pos" class="font-merriweather subtitle-product white--text" />
                          </template>
                          <v-list-item-subtitle v-else class="font-merriweather subtitle-product white--text">
                            {{ detail.description }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </template>
            <v-row v-else>
              <v-col cols="12">
                <v-list class="list-product-menu-book">
                  <template v-for="(detail, index) in item.items">
                    <v-list-item :key="index + '-product'" :ripple="false" @click="detailMenu(detail.id)">
                      <v-list-item-avatar size="88" tile class="rounded-lg">
                        <v-img :src="detail.photo_md" />
                      </v-list-item-avatar>
                      <v-list-item-content class="align-self-start">
                        <v-list-item-title v-if="detail.default_variant_id" class="font-merriweather title-product mb-2 theme0001--text">
                          {{ detail.alt_name === '' ? detail.name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'name') + ')' : detail.name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'name') + ')' + ' / ' + detail.alt_name + ' (' + $getObjectArray(detail.variants, 'id', detail.default_variant_id, 'alt_name') + ')' }}
                        </v-list-item-title>
                        <v-list-item-title v-else class="font-merriweather title-product mb-2 theme0001--text">
                          {{ detail.alt_name === '' ? detail.name : detail.name + ' / ' + detail.alt_name }}
                        </v-list-item-title>
                        <template v-if="$store.state.selected_store.setting.show_price_book_menu">
                          <v-list-item-subtitle v-if="detail.default_variant_id" v-mask-money="$getObjectArray(detail.variants, 'id', detail.default_variant_id, 'sell_price_pos')" class="subtitle-product white--text" />
                          <v-list-item-subtitle v-else v-mask-money="detail.sell_price_pos" class="font-merriweather subtitle-product white--text" />
                        </template>
                        <v-list-item-subtitle v-else class="font-merriweather subtitle-product white--text">
                          {{ detail.description }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="d-flex align-center justify-center">
            <div class="d-flex" style="width: 96px; height: 96px;">
              <lottie v-if="isLoading" :options="loadingOption" />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div class="powered-by-olsera">
      <div class="d-flex">
        <a href="https://bit.ly/3rU2JQ2" target="_blank">
          <img src="@/assets/images/powered-by-olsera.svg" alt="Powered by Olsera" class="img-powered">
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import Lottie from 'vue-lottie'
import loading_menubook from '@/assets/json/loading_menubook.json'
export default {
  components: {
    Lottie
  },
  props: {
    isLoading: {
      default: false,
      type: Boolean
    },
    listProduct: {
      default: () => [],
      type: Array
    },
    listCombo: {
      default: () => [],
      type: Array
    },
    onScroll: {
      required: true,
      type: Function
    },
    onScrollCombo: {
      required: true,
      type: Function
    },
    page: {
      required: true,
      type: Number
    },
    scrollTo: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      loadingOption: {
        animationData: loading_menubook
      }
    }
  },
  methods: {
    getImgUrl(img) {
      var images = require.context('@/assets/images/theme/theme0001/')
      return images('./' + img)
    },
    async detailMenu(id, product_type = 'product') {
      const obj = {
        page_to: this.page,
        scroll_to: this.scrollTo
      }
      sessionStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_handle_back', JSON.stringify(obj))
      this.$router.push({ name: 'detail_menu', params: { product_type: product_type, id: id }}).catch(e => {})
    }
  }
}
</script>

<style lang="css" scoped>
  .index-1 {
    z-index: 1 !important;
  }
  .theme0001--text{
    color: #F8E008;
  }
  .bg-theme0001{
    background-color: #232323 !important;
  }
  .p-relative{
    position: relative !important;
  }
  .banner {
    display: flex;
    flex: 1 1 auto;
  }
  .banner > img {
    width: 100%;
    height: 220px;
    object-fit: cover;
  }
  .title-group-product {
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
    color: #fff;
    font-size: 20px;
    font-family: 'Dancing Script', cursive;
  }
  .title-group-product:after {
    content: "";
    height: 100%;
    vertical-align: bottom;
    width: 100%;
    margin-right: -100%;
    margin-left: 10px;
    border-top: 1px solid #fff;
  }
  .yellow-card{
    background-color: #F8E008 !important;
    color: #000;
  }
  .card-product-grid {
    height: 100%;
  }
  .banner-text {
    background-color: #232323;
    position: relative;
    z-index: 0;
    overflow-x: clip;
    padding: 0px 36px;
  }
  .banner-text:after {
    background: #232323 0% 0% no-repeat padding-box;
    opacity: 1;
    filter: blur(29px);
    content: "";
    position: absolute;
    top: -100px;
    bottom: -100px;
    left: -60px;
    right: -60px;
  }
  .detail-store {
    color: #fff;
    position: relative;
    z-index: 1;
    border-top: solid #F8E008;
    border-bottom: solid #F8E008;
    padding: 16px 0px;
    font-family: 'Merriweather', serif;
    display: flex;
    align-items: center;
  }
  .detail-store-logo{
    display: flex;
    margin-right: 8px;
    align-items: center;
  }
  .detail-store-logo > img{
    width: 55px;
    height: 55px;
    object-fit: contain;
    display: flex;
    background-color: #fff;
    border-radius: 50%;
  }
  .title-store {
    color: #F8E008;
    font-size: 24px;
    margin-bottom: 4px;
  }
  .subtitle-store {
    font-size: 11px;
    font-weight: normal;
  }
  .bg-list-product{
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-attachment: fixed;
  }
  .v-list.list-product-menu-book {
    background: transparent !important;
  }
  .v-application .rounded-lg {
    border-radius: 8px!important;
  }
  .powered-by-olsera {
    position: fixed;
    bottom: 0;
    right: 0;
    background-color: #fff;
    border-radius: 35px 0 0 0;
    z-index: 1;
  }
  .powered-by-olsera a {
    line-height: normal;
  }
  .list-product-menu-book .title-product{
    font-size: 18px !important;
    white-space: initial;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
  .list-product-menu-book .subtitle-product{
    font-size: 13px !important;
    white-space: initial;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 16px !important;
  }
  .img-powered{
    width: 156px !important;
    height: auto;
  }
  .background-image-blur{
    position: fixed;
    left: 0;
    right: 0;
    z-index: 0;
    display: block;
    -webkit-filter: blur(5px);
    -moz-filter: blur(5px);
    -o-filter: blur(5px);
    -ms-filter: blur(5px);
    filter: blur(5px);
    height: 100vh;
    top: 0;
    background-size: cover;
  }
  @media (min-width: 600px) {
    .powered-by-olsera {
      margin-right: 25%;
    }
    .background-image-blur{
      left: 25%;
      right: 25%;
    }
  }
  @media (min-width: 960px) {
    .powered-by-olsera {
      margin-right: 33.3333333333%;
    }
    .background-image-blur{
      left: 33.3333333333%;
      right: 33.3333333333%;
    }
  }
</style>
